import { render, staticRenderFns } from "./ServiceTypeView.vue?vue&type=template&id=40c20e6b&scoped=true"
import script from "./ServiceTypeView.vue?vue&type=script&lang=js"
export * from "./ServiceTypeView.vue?vue&type=script&lang=js"
import style0 from "./ServiceTypeView.vue?vue&type=style&index=0&id=40c20e6b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c20e6b",
  null
  
)

export default component.exports